<!--
 - Author : wanghongling.
 - Date   : 2020/11/23.
 - File   : ring.环形饼图
 -->

<template>
  <div :id="id" :style="{width: ringObj.width, height: ringObj.height, margin:ringObj.margin}">
  </div>
</template>

<script>
  export default {
    name: 'my-ring',
    data() {
      return {
        myRing: null
      }
    },
    props: {
      id: {
        type: String,
        default: 'test'
      },
      ringObj: {
        default: () => {
          return {
            width: '190px',
            height: '190px',
            total: 100,
            barWidth: 8,
            margin: '0 auto'
          }
        },
        type: Object
      },
      val: {
        default: 0,
        type: Number
      },
      color: {
        default: '#25BFFF',
        type: String
      }
    },
    watch: {
      barList: {
        handler() {
          this.$nextTick(() => {
            window.removeEventListener('resize', this.resizeEvent)
            this.makeBar()
          })
        },
        deep: true
      }
    },
    destroyed() {
      this.$echarts.dispose(this.myRing)
      window.removeEventListener('resize', this.resizeEvent)
      this.myRing = null
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.myRing = this.$echarts.init(document.getElementById(this.id))
        this.makeRing()
      },
      makeRing() {
        let  getvalue = [this.val || 0]
        let option = {
          title: {
            text: getvalue,
            textStyle: {
              color: '#fff',
              fontSize: 20
            },
            itemGap: 10,
            left: 'center',
            top: 'center'
          },
          tooltip: {
            formatter: function () {
              return '<span style="color: #fff;">'+ getvalue + '</span>'
            }
          },
          angleAxis: {
            max: this.ringObj.total || 100,
            clockwise: true, // 逆时针
            // 隐藏刻度线
            show: false
          },
          radiusAxis: {
            type: 'category',
            show: true,
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          },
          polar: {
            center: ['50%', '50%'],
            radius: '185%' //图形大小
          },
          series: [{
            type: 'bar',
            data: getvalue,
            roundCap: true,
            showBackground: true,
            backgroundStyle: {
              color: '#0d3b6e'
            },
            coordinateSystem: 'polar',
            barWidth: this.ringObj.barWidth || 5,
            itemStyle: {
              normal: {
                opacity: 1,
                color:  this.color || '#25BFFF',
                shadowBlur: 5,
                shadowColor: 'rgba(0,0,0,0)'
              }
            },
            animationDuration: 2000,
            animationDurationUpdate: 400,
            animationEasing: 'cubicIn',
            animationDelay: function (idx) {
              return idx * 280 + 100
            }
          }]
        }
        this.myRing.setOption(option)
        window.addEventListener('resize', this.resizeEvent)
      },
      /**
       * echart图表适应
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      resizeEvent () {
        this.myRing.resize() // 使图表适应
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/echarts/ring.vue